module.exports = __webpack_public_path__ + "img/Raws_logo_white_NOTagline.56b8c4e8.svg";